export enum ServerErrors {
    SessionNotFound = -1,
    ObjectNotFound = -2,
    NotAllowed = -3,
    GlobalException = -4,
    RequestError = -5,
    TariffRestriction = -6
}



// WEBPACK FOOTER //
// ./src/app/shared/dictionaries/ServerErrors.ts